import { Controller } from "@hotwired/stimulus";

// Bascule les fieldsets Particulier / Entreprise du scan d'éligibilité.
//
// Le fieldset inactif est désactivé en plus d'être masqué : ses champs portent
// des contraintes `required` que le navigateur évaluerait quand même, et comme
// il ne peut pas donner le focus à un champ caché, la soumission échouerait
// sans rien afficher. `disabled` les sort de la validation ET de l'envoi.
export default class extends Controller {
  static targets = ["individualFields", "companyFields"];

  select(event) {
    this.#apply(this.individualFieldsTarget, event.currentTarget.value === "individual");
    this.#apply(this.companyFieldsTarget, event.currentTarget.value === "company");
  }

  #apply(fieldset, active) {
    fieldset.classList.toggle("d-none", !active);
    fieldset.disabled = !active;
  }
}
